/** Progressive navigation only. The complete legal wording is rendered by Liquid. */
class JatkaDocument extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-legal-document') || this.dataset.enhanced) return;
    this.dataset.enhanced = 'true';
    const content = this.querySelector('.jatka-document__content');
    const navigation = this.querySelector('.jatka-document__navigation');
    if (!content || !navigation) return;
    const headings = [...content.querySelectorAll('h2, h3, b')].filter(element => element.tagName !== 'B' || element.textContent.trim() === 'Załącznik nr 1 do Regulaminu');
    const normalize = text => text.trim().replace(/\s+/g, ' ').toLocaleLowerCase('pl');
    const slug = text => normalize(text).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const used = new Set([...document.querySelectorAll('[id]')].map(element => element.id));
    for (const heading of headings) {
      if (heading.id) continue;
      const base = `dokument-${slug(heading.textContent)}`;
      let id = base;
      let count = 2;
      while (used.has(id)) id = `${base}-${count++}`;
      used.add(id);
      heading.id = id;
      heading.tabIndex = -1;
    }
    const documentTitles = headings.filter(heading => heading.tagName === 'H2');
    const shortcuts = documentTitles.length > 1 ? documentTitles : headings.filter(heading => heading.tagName === 'H3' && !normalize(heading.textContent).startsWith('drogi użytkowniku'));
    if (shortcuts.length) {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = documentTitles.length > 1 ? 'Wybierz dokument' : 'Przejdź do sekcji';
      const list = document.createElement('ul');
      for (const heading of shortcuts) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim().replace(/\s+/g, ' ');
        item.append(link);
        list.append(item);
      }
      details.append(summary, list);
      navigation.append(details);
      navigation.hidden = false;
    }
    // Turn the existing paragraph-based tables of contents into real links.
    // Move original nodes to retain all labels and wording, including appendices.
    for (const paragraph of [...content.querySelectorAll('p')]) {
      if (!normalize(paragraph.textContent).startsWith('spis treści')) continue;
      const following = headings.filter(heading => paragraph.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING);
      const boundary = following.findIndex(heading => heading.tagName === 'H2');
      const targets = boundary === -1 ? following : following.slice(0, boundary);
      const lines = [[]];
      for (const node of [...paragraph.childNodes]) {
        if (node.nodeName === 'BR') lines.push([]);
        else lines.at(-1).push(node);
      }
      const details = document.createElement('details');
      details.className = 'jatka-document__toc';
      const summary = document.createElement('summary');
      const list = document.createElement('ul');
      for (const nodes of lines) {
        const text = normalize(nodes.map(node => node.textContent).join(''));
        if (!text) continue;
        if (text === 'spis treści') { summary.append(...nodes); continue; }
        const target = targets.find(heading => normalize(heading.textContent) === text || (text.startsWith('załącznik') && normalize(heading.textContent).startsWith('załącznik')));
        const item = document.createElement('li');
        if (target) {
          const link = document.createElement('a');
          link.href = `#${target.id}`;
          link.append(...nodes);
          item.append(link);
        } else item.append(...nodes);
        list.append(item);
      }
      details.append(summary, list);
      paragraph.replaceWith(details);
    }
  }
}
if (!customElements.get('jatka-document')) customElements.define('jatka-document', JatkaDocument);
